var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undo__Type=Undo, Style=Outline, Size=24",
    className: "undo__Type=Undo, undo__Style=Outline, undo__Size=24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undo__Line Duotone/Arrows Action/Undo Left Round",
    className: "undo__Line undo__Duotone/Arrows undo__Action/Undo undo__Left undo__Round"
  }, /*#__PURE__*/React.createElement("path", {
    id: "undo__Vector (Stroke)",
    fill: "currentColor",
    d: "M18.25 13.313a3.625 3.625 0 0 0-3.625-3.626H5a.75.75 0 0 1 0-1.5h9.625a5.125 5.125 0 0 1 0 10.25H8.5a.75.75 0 0 1 0-1.5h6.125a3.625 3.625 0 0 0 3.625-3.625Z",
    className: "undo__Vector undo__(Stroke)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "undo__Vector_2 (Stroke)",
    fill: "currentColor",
    d: "M7.095 5.782a.75.75 0 1 1 1.06 1.06L6.061 8.938l2.094 2.095.052.057a.75.75 0 0 1-1.056 1.056l-.056-.052L4.47 9.468a.75.75 0 0 1 0-1.06l2.625-2.626Z",
    className: "undo__Vector_2 undo__(Stroke)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoIcon);
export default __webpack_public_path__ + "static/media/undo_icon.aaa28712f49373d7d813f39e7a7ba401.svg";
export { ForwardRef as ReactComponent };